<script setup>
import { ref, onMounted } from 'vue'

const videoRef = ref(null)
const isPlaying = ref(false)
const isDismissed = ref(false)

const handleCtaClick = () => {
  if (isDismissed.value) return

  // 1. Trigger CSS slide-down animation
  isDismissed.value = true

  // 2. Play video after smooth 450ms slide out
  setTimeout(() => {
    startVideo()
  }, 450)
}

const startVideo = async () => {
  if (!videoRef.value || isPlaying.value) return

  try {
    isPlaying.value = true
    videoRef.value.currentTime = 2.5 
    await videoRef.value.play()
  } catch (err) {
    console.error("Playback failed:", err)
  }
}
</script>

<template>
  <div id="cover">
    <!-- Subtle Animated Postal Background Elements -->
    <div class="postal-bg-elements" aria-hidden="true">
      <div class="airmail-border top"></div>
      <div class="airmail-border bottom"></div>
      <span class="floating-icon icon-1">✉️</span>
      <span class="floating-icon icon-2">📩</span>
      <span class="floating-icon icon-3">💌</span>
      <span class="floating-icon icon-4">📮</span>
      <span class="floating-icon icon-5">📬</span>
    </div>

    <div class="grid-x cell small-12 text-center content-wrapper">
      <!-- Postbox Video Container -->
      <div class="cell small-12">
        <div class="postbox-container" @click="handleCtaClick">
          <video 
            ref="videoRef"
            src="/video/snail-mail.mp4" 
            preload="auto"
            playsinline 
            muted
            class="postbox-video"
          ></video>

          <!-- Red CTA Banner -->
          <div 
            v-if="!isPlaying" 
            id="click-here-cta" 
            class="rubik-m500 overlay-cta"
            :class="{ 'cta-hidden': isDismissed }"
          >
            <span class="key-icon">🔑</span>
            <span class="cta-text">CLICK TO UNLOCK</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@use "../assets/styles/snail-mail/snail-mail.scss";
</style>